import { GreenroomUpdateProfileMask } from '@/types/greenroom/profile.types';
import { Post } from '../helpers';

const UpdateGreenroomProfileMask = async (
  meetingId: number,
  body: GreenroomUpdateProfileMask
): Promise<GreenroomUpdateProfileMask> => {
  return Post({
    host: import.meta.env.VITE_GREENROOM_APP_SYNC_HOST,
    url: `/v1/room/${meetingId}/profile-masks/upsert`,
    body: body,
    includeIdToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default UpdateGreenroomProfileMask;
